import { actionTypes } from "./constants";
const initialState = {
  saleList: {
    list: [],
    total: 0,
  },
  saleListByAgent: {
    list: [],
    total: 0,
  },
  curSale: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_SALELIST:
      return {
        ...state, saleList: action.data, 
      };
    case actionTypes.SET_SALE_LIST_BY_AGENT:
      return {
        ...state, saleListByAgent: action.data, 
      };
    case actionTypes.SET_CURSALE:
      return {
        ...state, curSale: action.data, 
      };
    default:
      return state;
  }
};